import { Stripe } from '@stripe/stripe-js'
import { IClientInfo } from '../../models/clientInfo'
import {
  ConfigurationTypeKeys,
  IChangeLanguageAction,
  ICheckIfShowPaymentMethodAction,
  IFetchAreasAction,
  IFetchAreasSuccessfulAction,
  IFetchClientInfoAction,
  IFetchClientInfoSuccessfulAction,
  IResetAreaChangedAction,
  ISetAreaChangedAction,
  ISetIsFetchingAreasAction,
  ISetIsFetchingClientInfoAction,
  ISetSelectedAreaAction,
  ISetStripeAction,
  ISetShowPaymentMethodAction
} from '../types'

export function fetchAreasAction(): IFetchAreasAction {
  return { type: ConfigurationTypeKeys.FETCH_AREAS }
}

export function setIsFetchingAreasAction(): ISetIsFetchingAreasAction {
  return { type: ConfigurationTypeKeys.FETCHING_AREAS }
}

export function fetchAreasSuccessfulAction(areas: any): IFetchAreasSuccessfulAction {
  return { type: ConfigurationTypeKeys.FETCH_AREAS_SUCCESSFUL, payload: areas }
}

export function fetchClientInfoAction(): IFetchClientInfoAction {
  return { type: ConfigurationTypeKeys.FETCH_CLIENT_INFO }
}

export function setIsFetchingClientInfoAction(): ISetIsFetchingClientInfoAction {
  return { type: ConfigurationTypeKeys.FETCHING_CLIENT_INFO }
}

export function fetchClientInfosSuccessfulAction(clientInfo: IClientInfo): IFetchClientInfoSuccessfulAction {
  return { type: ConfigurationTypeKeys.FETCH_CLIENT_INFO_SUCCESSFUL, payload: clientInfo }
}

export function setSelectedAreaAction(selectedAreaId: number): ISetSelectedAreaAction {
  return { type: ConfigurationTypeKeys.SET_SELECTED_AREA, payload: selectedAreaId }
}

export function setChangeLanguageAction(lang: string): IChangeLanguageAction {
  return { type: ConfigurationTypeKeys.CHANGE_LANGUAGE, payload: lang }
}

export function setAreaChangedAction(): ISetAreaChangedAction {
  return { type: ConfigurationTypeKeys.SET_AREA_CHANGED }
}

export function resetAreaChangedAction(): IResetAreaChangedAction {
  return { type: ConfigurationTypeKeys.RESET_AREA_CHANGED }
}

export function setStripeAction(stripe: Stripe): ISetStripeAction {
  return { type: ConfigurationTypeKeys.SET_STRIPE, payload: stripe }
}

export function checkIfShowPaymentMethodAction(): ICheckIfShowPaymentMethodAction {
  return { type: ConfigurationTypeKeys.CHECK_IF_SHOW_PAYMENT_METHOD }
}

export function setShowPaymentMethodAction(show: boolean): ISetShowPaymentMethodAction {
  return { type: ConfigurationTypeKeys.SET_SHOW_PAYMENT_METHOD, payload: show }
}
